import router from './router'
import store from './store/store'
import { format } from 'util'
import { setToken, getToken } from '@/utils/token'
import { GetParam } from '@/utils/param'

//每次跳转时将地址的uid存入cookie中，如果没有则将cookie中原本的id存入地址中
// const whiteList = ['/Login']
// router.beforeEach((to, from, next) => {
// 	let uid = GetParam(from.fullPath, "uid")
// 	let token = null
// 	if (uid) {
// 		token = uid
// 		setToken(token)
// 		console.log("1  " + token)
// 	} else {
// 		token = getToken()
// 		console.log("2  " + token)
// 	}

// 	if (whiteList.includes(to.path)) {
// 		next()
// 	} else {
// 		if (!to.query.uid && to.fullPath !== "/Login") {
// 			next({
// 				path: to.path,
// 				query: { uid: token }
// 			})
// 		} else {
// 			next()
// 		}
// 	}


// })
router.beforeEach((to, from, next) => {
  // console.log('44444')
  let uid = GetParam(from.fullPath, "uid")
  // let uid =""
  // console.log(uid)
  let token = null
  if (uid) {
    token = uid
    setToken(token)
    // console.log("1  " + token)
  } else {
    // console.log('1111')
    token = getToken()
    // console.log(token)
    // console.log("2  " + token)
  }
  if (to.fullPath === "/") {
    next({ path: '/Login' })
    // console.log("3  " + token)
  } else {
    // console.log('6666')
    console.log(to.fullPath)
    if (!to.query.uid && to.fullPath !== "/Login") {
      // console.log("4  " + token)
      // console.log(token)
      if (token) {
      //   console.log('888888')
      //   next({
      //     path: to.path,
      //     query: { uid: token }
      //   })
      // } else {
        next()
      }else{
        next()
      }
      // if (to.fullPath == '/VipLogin' || to.fullPath == '/Vipfirst') {
      
      // } else {


      // }
    } else {
      // console.log('777')
      next()
      // console.log("5  " + token)
    }
  }
})

// const whiteList = ['/Login']
// router.beforeEach((to, from, next) => {
//     let uid = GetParam(from.fullPath,"uid")
//     let token = null
//     if(uid){
//         token = uid
//         setToken(token)
//         console.log("1  "+token)
//     }else{
//         token = getToken()
//         console.log("2  "+token)
//     }
//



//     if (token) {
//         next()
//     } else {
//         if (whiteList.includes(to.path)) {
//             next()
//         } else {
//             next(`/Login?redirect=${to.path}`)
//         }
//     }
//     next()
// })



// WEBPACK FOOTER //
// ./src/permission.js